import { graphql } from "../../generated"

export const UNEXPECTED_METRIC = graphql(`
    query unexpectedMetric($input: AlertMetricValuesInput!) {
        metricValues(input: $input) {
            results {
                metric
                values {
                    wellID
                    value
                }
            }
        }
    }
`)
